import _asyncToGenerator from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { Ge as O, hi as S, bo as g, Qo as u, di as k, w, M as b, fi as R } from "./abstract-base-8edf0a84-e11d45a3.js";
import { e as y } from "./state-b4c9cc73-ee633f6c.js";
import { E as z, a as $ } from "./keys-b2183e45-74d07070.js";
import { A as d, N as I } from "./tab-variant-3de435f9-0500ceb3.js";
import { X as P } from "./focus-trap-9eb080a8-1674051e.js";
import { N as v, k as D, A } from "./query-assigned-ba663908-228b08f4.js";
import { d as B, o as V } from "./scroll-6ed94e8f-e2cbd6af.js";
import { a as N } from "./uid-a0afd8c4-59f5d89c.js";
import { n as T } from "./breakpoints-1ea07f11-d0da757c.js";
import "./lifecycle-decorators-ecc4e836-92da4b80.js";
import "./helper-dd9a664c-e404f685.js";
import "./query-24926cff-3eb94bfb.js";
import "./variables-37cba309-153935bd.js";
var m = /* @__PURE__ */function (o) {
  return o[o.DEFAULT = 4] = "DEFAULT", o[o.MEDIUM = 5] = "MEDIUM", o[o.LARGE = 7] = "LARGE", o[o.XLARGE = 7] = "XLARGE", o;
}(m || {});
var U = O(_templateObject || (_templateObject = _taggedTemplateLiteral([".beacon-theme-modern-outlook[beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook [beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook[beacon-version=\"3.0.0\"][beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook[beacon-version=\"3.0.0\"] [beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook [beacon-version=\"3.0.0\"][beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook [beacon-version=\"3.0.0\"] [beacon-tag-name=beacon-tabs]{--caption-300-line-height: var(--beacon-reference-space-5);--tabs-size-block-size-secondary: calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating) + var(--caption-300-line-height) + var(--beacon-system-width-border-normal));--tabs-menu-item-space-padding: calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating));--tabs-tab-title-space-margin-block-end: 0;--tabs-tab-title-space-margin-block-start: 0;--tabs-tab-title-space-margin-inline: 0;--tabs-tab-icon-space-margin-block: 0;--tabs-tab-icon-space-margin-inline-start: 0;--tabs-tab-title-space-secondary-margin-block-start: 0;--tabs-tab-title-space-secondary-margin-inline-start: 0;--tabs-menu-item-space-padding-block-start: 0;--tab-padding: calc(2 * var(--beacon-system-space-cell-contained));--tab-space-secondary-padding-block: calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating));--tab-icon-align-self: center;--tab-span-align-self: center;--tabs-tab-size-inline-size: inherit;--tabs-tab-size-min-inline-size: max-content;--tabs-tab-size-max-inline-size: unset;--tabs-tab-flex-direction: row}@media (min-width: 640px){.beacon-theme-modern-outlook[beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook [beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook[beacon-version=\"3.0.0\"][beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook[beacon-version=\"3.0.0\"] [beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook [beacon-version=\"3.0.0\"][beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook [beacon-version=\"3.0.0\"] [beacon-tag-name=beacon-tabs]{--caption-300-line-height: var(--beacon-reference-space-6)}}@media (min-width: 960px){.beacon-theme-modern-outlook[beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook [beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook[beacon-version=\"3.0.0\"][beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook[beacon-version=\"3.0.0\"] [beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook [beacon-version=\"3.0.0\"][beacon-tag-name=beacon-tabs],.beacon-theme-modern-outlook [beacon-version=\"3.0.0\"] [beacon-tag-name=beacon-tabs]{--caption-300-line-height: var(--beacon-reference-space-7)}}\n"])));
function Y(o) {
  return o <= T.DEFAULT ? m.DEFAULT : o <= T.MEDIUM ? m.MEDIUM : o <= T.LARGE ? m.LARGE : m.XLARGE;
}
function j(o, e) {
  var t = o.scrollTop,
    a = 0,
    i = "scrolled-close-button-row",
    r = e.classList.contains(i);
  t !== a && e.classList.add(i), t === a && r && e.classList.remove(i);
}
function F(o) {
  return {
    firstVisibleTabIndex: 0,
    lastVisibleTabIndex: o - 1
  };
}
function X(o, e, t, a) {
  var i = e - 1,
    r = t - 1,
    l = a ? 1 : 0,
    c = {
      firstVisibleTabIndex: 0,
      lastVisibleTabIndex: i - l
    };
  return t < e && (c.lastVisibleTabIndex = r), o >= e && (c.firstVisibleTabIndex = o - i, c.lastVisibleTabIndex = o - l), c;
}
function x(o, e, t, a, i) {
  return i ? F(t) : X(o, e, t, a);
}
var G = O(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([":host{margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large)}::slotted([beacon-tag-name=beacon-tab]),[beacon-tag-name=beacon-tab]{inline-size:100%}::slotted([beacon-tag-name=beacon-tab][variant=secondary]),::slotted([beacon-tag-name=beacon-tab][variant=tertiary]){inline-size:fit-content;margin-inline-end:var(--beacon-system-space-micro-maxi, var(--beacon-tabs-vertical-spacer-size-inline))}::slotted([beacon-tag-name=beacon-tab][variant=secondary]:last-of-type),::slotted([beacon-tag-name=beacon-tab][variant=tertiary]:last-of-type){margin-inline-end:0}.tablist,.menu-tablist{display:flex;inline-size:100%}.tablist{-webkit-hyphens:auto;hyphens:auto;max-inline-size:100vw;overflow-wrap:anywhere}.menu-tablist{flex-direction:column;overflow:auto;padding-block-start:var(--beacon-system-space-cell-contained)}:host([tab-type=stacked-icon][scrollable]),:host([tab-type=inline-icon][scrollable]){--tab-width-non-scrollable: 100%}:host([tab-type=stacked-icon][scrollable]) .tablist,:host([tab-type=inline-icon][scrollable]) .tablist{inline-size:max-content}:host([tab-type=inline-icon][scrollable][variant=secondary]) .tablist{inline-size:100%}:host([variant=secondary]) .container{block-size:var(--tabs-size-block-size-secondary, var(--beacon-tabs-tab-size-block-size-secondary));border-block-end:var(--beacon-system-width-border-normal, 2px) solid var(--beacon-system-color-border-0, var(--beacon-tabs-horizontal-line-color-default));margin-block:var(--beacon-system-space-micro-maxi, var(--beacon-unit-atomic))}:host([variant=tertiary]) .container{block-size:var(--beacon-tabs-tab-size-block-size-tertiary);margin-block:var(--beacon-system-space-micro-maxi, var(--beacon-unit-atomic))}:host([variant=secondary][scrolled]) .container,:host([variant=tertiary][scrolled]) .container{inline-size:100vw;inset-inline-start:0;position:absolute}:host([variant=secondary][scrolled]) .spacer{block-size:calc(var(--beacon-unit-base) + var(--beacon-tabs-tab-size-block-size-secondary))}:host([variant=tertiary][scrolled]) .spacer{block-size:calc(var(--beacon-unit-base) + var(--beacon-tabs-tab-size-block-size-tertiary))}:host([scrollable]){--scrollbar-visible: hidden;--scrollbar-hover-visible: hidden}:host([scrollable]) ::-webkit-scrollbar{inline-size:var(--beacon-scrollbar-size-inline)}:host([scrollable]) ::-webkit-scrollbar-thumb{background:var(--beacon-scrollbar-color-background);background-clip:content-box;border:var(--beacon-scrollbar-size-border) solid transparent;border-radius:var(--beacon-scrollbar-size-border-radius)}:host([scrollable]) .tablist{overflow-x:auto}:host([scrollable]) .tablist:hover{--scrollbar-visible: var(--scrollbar-hover-visible)}:host([scrollable]) .tablist:focus-within{overflow-x:visible}:host([scrollable]) ::-webkit-scrollbar-thumb{visibility:var(--scrollbar-visible)}:host(:not([scrollable])) dialog{--override-icon-button-bg-color: var(--beacon-system-color-background-primary, var(--beacon-colors-light-blue-1));--override-icon-button-bg-color-hover: var(--beacon-colors-medium-blue-1);--override-icon-button-bg-color-pressed: var(--beacon-colors-dark-blue-1)}:host([overflowing-x=true]:not([scrollable])){--tabs-overflow-wrapping: normal}:host([tab-type=stacked-icon]:not([scrollable])){--tab-width-non-scrollable: 100%}.overlay{--close-button-padding-block: var(--beacon-reference-space-3, var(--beacon-unit-atomic)) 0;align-items:center;background-color:var(--beacon-tabs-overlay-color-background);display:flex;flex-direction:column;inline-size:100%;top:0;right:0;bottom:0;left:0;justify-content:center;position:fixed}.overlay ::-webkit-scrollbar{inline-size:var(--beacon-scrollbar-size-inline)}.overlay ::-webkit-scrollbar-thumb{background:var(--beacon-scrollbar-color-background);background-clip:content-box;border:var(--beacon-scrollbar-size-border) solid transparent;border-radius:var(--beacon-scrollbar-size-border-radius)}.overlay dialog{align-items:center;background-color:var(--beacon-system-color-background-primary, var(--beacon-colors-light-blue-1));block-size:100dvh;border:0;box-shadow:var(--beacon-elevation-block-end-level-1);box-sizing:border-box;display:flex;flex-direction:column;inline-size:var(--beacon-tabs-menu-size-max-inline-size);max-block-size:var(--beacon-tabs-menu-size-max-block-size);padding:0}.overlay dialog h2{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-serif-headline-200, var(--beacon-headline-font-size-200)/var(--beacon-headline-font-line-height-module-200) var(--beacon-font-family-default));color:var(--beacon-tabs-color-text-primary-default);display:flex;margin:0}.overlay dialog .close-button-row{background-color:var(--beacon-system-color-background-primary, var(--beacon-colors-light-blue-1));display:flex;flex-direction:row-reverse;inline-size:100%;inset-block-start:0;padding:var(--beacon-reference-space-3);position:sticky}.overlay dialog .close-button-row [beacon-tag-name=beacon-icon-button]{padding-block:var(--close-button-padding-block);padding-inline-end:var(--beacon-reference-space-3, var(--beacon-unit-atomic))}.overlay dialog .scrolled-close-button-row{--close-button-padding-block: var(--beacon-reference-space-3, var(--beacon-unit-atomic));box-shadow:var(--beacon-elevation-block-end-level-1)}.overlay dialog .menu-item{--menu-item-underline: initial;align-items:center;background-color:var(--beacon-system-color-background-primary, var(--beacon-colors-light-blue-1));border:0;box-sizing:border-box;color:var(--beacon-system-color-text-primary, var(--beacon-tabs-color-text-primary-default));cursor:default;display:flex;inline-size:100%;justify-content:center;min-block-size:var(--beacon-tabs-menu-item-size-block-size);padding:var(--tabs-menu-item-space-padding, var(--beacon-unit-atomic))}.overlay dialog .menu-item[active]{background-color:var(--beacon-component-tab-menu-color-background-primary-active, var(--beacon-colors-dark-blue))}.overlay dialog .menu-item[active] span{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-sans-serif-body-200, var(--beacon-body-font-size-200)/var(--beacon-body-font-line-height-module-200) var(--beacon-font-family-default))}.overlay dialog .menu-item span{font:var(--beacon-system-font-weight-light, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-200, var(--beacon-body-font-size-200)/var(--beacon-body-font-line-height-module-200) var(--beacon-font-family-default));padding-block-start:var(--tabs-menu-item-space-padding-block-start, var(--beacon-unit-subatomic));text-decoration:var(--menu-item-underline)}.overlay dialog .menu-item:focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1;align-self:center;inline-size:calc(100% - var(--total-ring-width))}.overlay dialog button.menu-item{cursor:pointer}.overlay dialog button.menu-item:hover{--menu-item-underline: underline}.overlay dialog button.menu-item:first-of-type{margin-block-start:var(--beacon-tabs-menu-item-space-margin-block-start)}.overlay dialog button.menu-item:last-of-type{margin-block-end:var(--beacon-system-space-organism-jumbo, var(--beacon-tabs-menu-item-space-margin-block-end))}.hide,::slotted(.hide){display:none}@media (min-width: 320px){:host([tab-type=inline-icon]){--tab-width-non-scrollable: 100%}:host([tab-type=inline-icon]) .tablist{inline-size:100%}}@media (min-width: 640px){:host([scrollable][variant=primary]){--scrollbar-hover-visible: visible}.overlay dialog{block-size:unset;max-block-size:100dvh}}\n"])));
var W = Object.defineProperty,
  K = Object.getOwnPropertyDescriptor,
  s = function s(o, e, t, a) {
    for (var i = a > 1 ? void 0 : a ? K(e, t) : e, r = o.length - 1, l; r >= 0; r--) (l = o[r]) && (i = (a ? l(e, t, i) : l(i)) || i);
    return a && i && W(e, t, i), i;
  };
var L = "beacon-tabs",
  H = ["beacon-icon-button", "beacon-tab"],
  h = "hide",
  q = "1",
  M = "",
  Q = "tabChildren",
  C = "value",
  J = "currentMaxTabs",
  Z = "scrollable",
  _ = "tabType",
  ee = "variant",
  te = 2,
  ae = "DIALOG",
  oe = "tab-list",
  ie = 320;
var n = /*#__PURE__*/function (_S) {
  _inherits(n, _S);
  function n() {
    var _this;
    _classCallCheck(this, n);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(n).apply(this, arguments)), _this.beaconTagName = L, _this.focusOverride = !0, _this.currentTotalTabs = 0, _this.currentMaxTabs = m.XLARGE, _this.scrollable = !1, _this.scrolled = !1, _this.closeOnClickOut = !0, _this.variant = d.PRIMARY, _this.tabType = I.STACKED_ICON, _this.menuTitle = "Choose a view:", _this.selected = M, _this.menuOpen = !1, _this.markedAsOverflowingX = !1, _this.markedAsMenuOverFlowingY = !1, _this.id = N(), _this.tabsResizeObserver = new ResizeObserver(function (e) {
      var t, a;
      var i, r;
      var l = e.find(function (f) {
          return f;
        }),
        c = l.borderBoxSize,
        p = l.contentRect;
      if (c && (r = Array.isArray(c) ? c[0] : c), ((t = l == null ? void 0 : l.target) == null ? void 0 : t.tagName) === ae && _this.menuOpen && !_this.markedAsMenuOverFlowingY) {
        var f = Math.ceil(r.blockSize || p.height),
          E = l.target.scrollHeight;
        _this.observeHeight(f, E);
      } else (l == null ? void 0 : l.target.id) === oe ? (i = Math.ceil(r.inlineSize || p.width), _this.observePrimaryTabsWidth(i)) : (i = Math.ceil((a = r.inlineSize || (p == null ? void 0 : p.width)) != null ? a : 0), _this.observeBodyWidth(i));
    }), _this.toggleTabListScrollClass = function () {
      var e = _this.tabListElement.scrollLeft;
      e === 0 ? _this.scrolled = !1 : _this.scrolled = !0;
    }, _this.buildTabMenuItem = function (e) {
      return g(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<button\n      role=\"tab\"\n      value=\"", "\"\n      ?active=\"", "\"\n      class=\"menu-item\"\n      aria-selected=\"", "\"\n      @click=", "\n    >\n      <span>", "</span>\n    </button>"])), e.value, e.active, e.active, _this.handleMenuTabClick, e.label);
    }, _this.buildTabMenu = function (e) {
      return g(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), e.map(function (t) {
        return _this.buildTabMenuItem(t);
      }));
    };
    return _this;
  }
  _createClass(n, [{
    key: "observePrimaryTabsWidth",
    /**
     * Observer logic to conditionally apply the overflow class
     * and update the max amount of visible tabs allowed based
     * on an input tabList width
     * @param width the width of the tablist contentRect
     */
    value: function observePrimaryTabsWidth(e) {
      this.handleOverflowing();
      var t = Y(e);
      this.currentMaxTabs !== t && (this.currentMaxTabs = t, this.requestUpdate());
    }
    /**
     * Conditionally applies a scroll listener to the moreMenu if and only if the moreMenu is overflowing
     * for the first time
     * @param moreMenuHeight the height of the more menu currently visible on the screen
     * @param moreMenuScrollHeight the complete height of the more menu including what's vertically scrollable
     */
  }, {
    key: "observeHeight",
    value: function observeHeight(e, t) {
      var _this2 = this;
      this.closeButtonRow && e < t && (this.markedAsMenuOverFlowingY = !0, this.tabMenu.addEventListener(u.SCROLL, function () {
        j(_this2.tabMenu, _this2.closeButtonRow);
      }));
    }
    /**
     * Checks the width of the body element. If it's at mobile breakpoint width adds scroll listener that toggles
     * full-width 'scrolled' styles for tab-list. For performance reasons, removes scroll listener when width is
     * bigger than mobile breakpoint.
     * @param width of the body element
     */
  }, {
    key: "observeBodyWidth",
    value: function observeBodyWidth(e) {
      e <= ie ? (this.toggleTabListScrollClass(), this.tabListElement.addEventListener(u.SCROLL, this.toggleTabListScrollClass)) : (this.tabListElement.removeEventListener(u.SCROLL, this.toggleTabListScrollClass), this.scrolled = !1);
    }
    /**
     * checks the scrollWidth of the tab list element,
     * then compares the scrollWidth to the window innerWidth
     * to determine if the tabs are overflowing.
     * Applies an overflow class to the tabs if they are overflowing.
     */
  }, {
    key: "handleOverflowing",
    value: function handleOverflowing() {
      var e = !1;
      var t = Math.ceil(this.tabListElement.getBoundingClientRect().width);
      this.markedAsOverflowingX || (e = this.TabsWidth > t), e && !this.markedAsOverflowingX && (this.markedAsOverflowingX = !0);
    }
    /**
     * Attaches keydown listener to handle menu key inputs when the component is first loaded.
     */
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;
      var e;
      (e = this.handleDefer()) == null || e.then(function () {
        _get(_getPrototypeOf(n.prototype), "connectedCallback", _this3).call(_this3);
      }), this.getRootNode().addEventListener(u.KEYDOWN, function (t) {
        return _this3.handleMenuKeydown(t);
      });
    }
    /**
     * disposes of the keydown event listener and tabListObserver
     * upon component disconnect.
     */
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this4 = this;
      this.getRootNode().removeEventListener(u.KEYDOWN, function (e) {
        return _this4.handleMenuKeydown(e);
      }), this.tabsResizeObserver.disconnect(), (this.variant === d.SECONDARY || this.variant === d.TERTIARY) && this.tabListElement.removeEventListener(u.SCROLL, this.toggleTabListScrollClass), _get(_getPrototypeOf(n.prototype), "disconnectedCallback", this).call(this);
    }
    /**
     * function attached to the more menu's close button
     * that hides the menu upon clicking.
     * @param event a user interaction generated Click event
     */
  }, {
    key: "handleClose",
    value: function handleClose(e) {
      e.stopPropagation(), this.hideMenu();
    }
    /**
     * sets the clicked tab to active,
     * and updates the rendering according to updateCurrentlyActiveTab
     * @param event a user interaction generated Click event
     */
  }, {
    key: "handleTabClick",
    value: function handleTabClick(e) {
      _get(_getPrototypeOf(n.prototype), "emitClick", this).call(this, e);
      var t = e.target;
      t.value && this.updateCurrentlyActiveTab(t.value);
    }
    /**
     * Traps the focus within the more menu if it's currently open.
     * Closes the More menu if Escape is pressed,
     * and handles tab presses or arrow presses to navigate
     * the more menu
     * @param event a user interaction created KeyboardEvent
     */
  }, {
    key: "handleMenuKeydown",
    value: function handleMenuKeydown(e) {
      this.menuOpen && e.isTrusted && (e.key === z.TAB && this.handleFocusTabbing(e, this.tabMenuOverlay), Object.values($).includes(e.key) && this.handleFocusArrowKeys(e, this.tabMenuOverlay), e.key === z.ESCAPE && this.hideMenu());
    }
    /**
     * Sets the tabs selected attribute,
     * then sets the currently visible tab and tab panel
     * to match the selected attribute
     * @param selected the value attribute of a clicked tab or tab menu-item
     */
  }, {
    key: "updateCurrentlyActiveTab",
    value: function updateCurrentlyActiveTab(e) {
      this.selected = e, this.deselectAllTabs(), this.hideAllTabPanels(), this.selectClickedTab(this.selected), this.displaySelectedTabPanel(this.selected);
    }
    /**
     * Closes the more menu and
     * Sets which tab is currently active based on the menu item clicked,
     * then shifts the visible tab range to match if the clicked tab value
     * is greater than what's currently visible.
     * @param event A user generated Click event
     */
  }, {
    key: "handleMenuTabClick",
    value: function handleMenuTabClick(e) {
      var t = e.currentTarget;
      _get(_getPrototypeOf(n.prototype), "emitClick", this).call(this, e);
      var a = parseInt(t.getAttribute(C), 10),
        i = x(a, this.currentMaxTabs, this.currentTotalTabs, this.shouldShowMore, this.scrollable);
      this.updateCurrentlyActiveTab(t.getAttribute(C)), this.showTabsInRange(i, this.tabChildren), this.hideMenu();
    }
    /**
     * Closes the more menu dialog, when the user clicks outside of the dialog and
     * the closeOnClickOut parameter is true.
     * @param event a user interaction generated Click event
     */
  }, {
    key: "handleMenuClickBlur",
    value: function handleMenuClickBlur(e) {
      this.closeOnClickOut && this.menuOpen && e.target === this.tabMenuOverlay && this.hideMenu();
    }
    /**
     * Sets currently active tab of the slotted tabChildren based on the clicked tab's value
     * @param clickedValue the value attribute of a user clicked tab
     */
  }, {
    key: "selectClickedTab",
    value: function selectClickedTab(e) {
      this.tabChildren.forEach(function (t) {
        t.value === e && (t.active = !0);
      });
    }
    /**
     * sets the active value of each slotted tab to false
     */
  }, {
    key: "deselectAllTabs",
    value: function deselectAllTabs() {
      this.tabChildren.forEach(function (e) {
        e.active = !1;
      });
    }
    /**
     * Removes the hide class from the tab panel with a value matching the input value attribute
     * @param clickedValue the value attribute of the tab clicked corresponding with the tab panel value
     */
  }, {
    key: "displaySelectedTabPanel",
    value: function displaySelectedTabPanel(e) {
      this.tabPanels.forEach(function (t) {
        t.value === e && (t.active = !0);
      });
    }
    /**
     * Applies the hide class to each slotted tab panel
     * setting their display to none.
     */
  }, {
    key: "hideAllTabPanels",
    value: function hideAllTabPanels() {
      this.tabPanels.forEach(function (e) {
        e.active = !1;
      });
    }
    /**
     * applies the hide css class to the overlay div
     * to hide the more menu modal.
     * Triggered by blur, the menu close button, or clicking an option
     */
  }, {
    key: "hideMenu",
    value: function hideMenu() {
      this.tabMenuOverlay.classList.add(h), this.menuOpen = !1, this.tabsResizeObserver.unobserve(this.tabMenu), B();
    }
    /**
     * remove the hide css class from the overlay div
     * to show the more menu modal.
     * Triggered by blur, or menu click
     * Focuses on first tabbable element within the more menu
     */
  }, {
    key: "showMenu",
    value: function showMenu() {
      this.tabMenuOverlay.classList.remove(h), this.menuOpen = !0, this.tabsResizeObserver.observe(this.tabMenu), this.closeButton.focus(), V();
    }
    /**
     * applies the hide class setting display to none on the input tab
     * @param tab BeaconTab in the tabChildren slot to hide
     */
  }, {
    key: "hideTab",
    value: function hideTab(e) {
      e.classList.add(h);
    }
    /**
     * removes the hide class setting display to none on the input tab
     * @param tab BeaconTab in the tabChildren slot to show
     */
  }, {
    key: "showTab",
    value: function showTab(e) {
      e.classList.remove(h);
    }
    /**
     * Getter for all currently slotted tabs without the .hide class applied
     * @param tabs an Array of slotted Beacon Tab components
     * @returns an array of tabs without the .hide class applied
     */
  }, {
    key: "getVisibleTabs",
    value: function getVisibleTabs(e) {
      return e.filter(function (t) {
        return !t.classList.contains(h);
      });
    }
    /**
     * Hides all tabs outside of the specified range
     * and shows all tabs inside the range by applying and
     * removing the hide class to the slotted tabChildren
     * @param firstVisibleTabIndex the inclusive starting index range to show tabs
     * @param lastVisibleTabIndex the inclusive ending index range to show tabs
     * @param tabs the slotted tabChildren
     */
  }, {
    key: "showTabsInRange",
    value: function showTabsInRange(_ref, a) {
      var _this5 = this;
      var e = _ref.firstVisibleTabIndex,
        t = _ref.lastVisibleTabIndex;
      a.forEach(function (i, r) {
        r < e || r > t ? _this5.hideTab(i) : _this5.showTab(i);
      });
    }
    /**
     * Applies the .hide class setting display: none on
     * each slotted tab component.
     */
  }, {
    key: "hideAllTabs",
    value: function hideAllTabs() {
      this.tabChildren.forEach(function (e) {
        e.classList.add(h);
      });
    }
    /**
     * Removes the .hide class from each slotted tab component.
     */
  }, {
    key: "showAllTabs",
    value: function showAllTabs() {
      this.tabChildren.forEach(function (e) {
        e.classList.remove(h);
      });
    }
    /**
     * Overridden.
     * checks if the amount of slotted tabChildren changed, to update the "watching"
     * currentTotalTab attribute accordingly.
     * Also calls updateShownTabs() to re-render tabs accordingly, when the max amount
     * of visible tabs allowed changes.
     * @param changedProperties Inherited Map of properties changed during a component's update lifeCycle
     */
  }, {
    key: "willUpdate",
    value: function () {
      var _willUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              e.has(Q) && (this.currentTotalTabs = this.tabChildren.length), e.has(J) && this.updateShownTabs(), e.has(Z) && this.updateShownTabs(), e.has(_) && this.applyTabType(this.tabChildren), e.has(ee) && this.applyTabVariant(this.tabChildren);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function willUpdate(_x) {
        return _willUpdate.apply(this, arguments);
      }
      return willUpdate;
    }()
    /**
     * Repeated update lifecyle logic to update tab visibility based on which value is currently selected.
     * Will shift the visible tab range downwards if the max tabs allowed decreases on a resize.
     */
  }, {
    key: "updateShownTabs",
    value: function updateShownTabs() {
      var e = parseInt(this.selected, 10),
        t = x(e, this.currentMaxTabs, this.currentTotalTabs, this.shouldShowMore, this.scrollable);
      this.showTabsInRange(t, this.tabChildren);
    }
    /**
     * Applies the variant attribute from the parent to all slotted
     * tab components
     * @param tabs the slotted Tab Components from this.tabChildren
     */
  }, {
    key: "applyTabVariant",
    value: function applyTabVariant(e) {
      var _this6 = this;
      e.forEach(function (t) {
        t.variant = _this6.variant;
      });
    }
    /**
     * Applies the tabType attribute from the parent to all slotted
     * tab components
     * @param tabs the slotted Tab Components from this.tabChildren
     */
  }, {
    key: "applyTabType",
    value: function applyTabType(e) {
      var _this7 = this;
      (this.variant === d.PRIMARY || d.SECONDARY) && e.forEach(function (t) {
        t.tabType = _this7.tabType;
      });
    }
    /**
     * Iterates over the loaded tabPanels and sets their
     * value attribute to 1 + index. Necessary for tab hiding
     * and shifting logic.
     * @param tabs the loaded Array of slotted Beacon Tab components
     */
  }, {
    key: "initializeTabValues",
    value: function initializeTabValues(e) {
      e.forEach(function (t, a) {
        t.value = "".concat(a + 1);
      });
    }
    /**
     * Iterates over the loaded tabPanels and sets their
     * value attribute to 1 + index. Necessary for tab hiding
     * and shifting logic.
     * @param tabPanels the loaded Array of slotted Beacon Tab Panel components
     */
  }, {
    key: "initializeTabPanelValues",
    value: function initializeTabPanelValues(e) {
      e.forEach(function (t, a) {
        t.value = "".concat(a + 1);
      });
    }
    /**
     * Iterates over the loaded tabPanels and prefixes their IDs with the tab component's
     * input or randomly generated Unique ID
     * @param tabPanels the loaded Array of slotted Beacon Tab Panel components
     * @param uniqueID the Tab Component's input ID or randomly generated fallback ID.
     */
  }, {
    key: "initializeTabPanelIDs",
    value: function initializeTabPanelIDs(e, t) {
      e.forEach(function (a) {
        a.id = "".concat(t, "-tabpanel-").concat(a.value);
      });
    }
    /**
     * Iterates over the loaded tab components and prefixes their IDs with the tab component's
     * input or randomly generated Unique ID. Also updates attributes dependent on the tab ID including
     * ariaControls.
     * @param tabPanels the loaded Array of slotted Beacon Tab components
     * @param uniqueID the Tab Component's input ID or randomly generated fallback ID.
     */
  }, {
    key: "initializeTabIDs",
    value: function initializeTabIDs(e, t) {
      e.forEach(function (a) {
        a.id = "".concat(t, "-tab-").concat(a.value), a.ariaControls = "".concat(t, "-tabpanel-").concat(a.value);
      });
    }
    /**
     * Fallback case for the initially selected tab when the user selected value
     * is invalid or not supplied. Sets the first tab and tab panel to active.
     */
  }, {
    key: "setActiveToFirst",
    value: function setActiveToFirst() {
      this.updateCurrentlyActiveTab(q);
    }
    /**
     * Sets the currently active tab to the string input,
     * if the string input is within the range of currently slotted tabs,
     * and sets the active tab to the first slotted tab otherwise.
     * @param selected tab with matching value to set as active, this.selected
     * @param currentTotalTabs the length of currently slotted tab array, this.currentTotalTabs
     */
  }, {
    key: "initializeUserSelectedTab",
    value: function initializeUserSelectedTab(e, t) {
      var a = parseInt(this.selected, 10);
      a > t || a < 0 ? this.setActiveToFirst() : this.updateCurrentlyActiveTab(e);
    }
    /**
     * Sets the currently active tab to the user supplied selected value
     * if it exists and is valid, or to the first slotted tab otherwise.
     * @param selected tab with matching value to set as active, this.selected
     * @param currentTotalTabs the length of currently slotted tab array, this.currentTotalTabs
     */
  }, {
    key: "initializeSelectedTab",
    value: function initializeSelectedTab(e, t) {
      e !== M ? this.initializeUserSelectedTab(e, t) : this.setActiveToFirst();
    }
  }, {
    key: "handleSlotChange",
    value: function () {
      var _handleSlotChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.initializeTabs();
            case 2:
              this.requestUpdate();
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleSlotChange(_x2) {
        return _handleSlotChange.apply(this, arguments);
      }
      return handleSlotChange;
    }()
    /**
     * When the tabs component first Updates or the slot changes, it waits for the slotted
     * tab, and tab panel components, selects the appropriate tab, hides the rest,
     * and applies some attributes from the tabs component to each tab/ tab panel, then
     * hides the tabMenuOverlay if it's shown.
     */
  }, {
    key: "initializeTabs",
    value: function () {
      var _initializeTabs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return Promise.all(this.tabChildren.map(function (e) {
                return e.updateComplete;
              }));
            case 2:
              _context3.next = 4;
              return Promise.all(this.tabPanels.map(function (e) {
                return e.updateComplete;
              }));
            case 4:
              this.currentTotalTabs = this.tabChildren.length;
              this.initializeTabPanelValues(this.tabPanels);
              this.initializeTabValues(this.tabChildren);
              this.initializeTabPanelIDs(this.tabPanels, this.id);
              this.initializeTabIDs(this.tabChildren, this.id);
              this.updateShownTabs();
              this.applyTabVariant(this.tabChildren);
              this.applyTabType(this.tabChildren);
              this.initializeSelectedTab(this.selected, this.currentTotalTabs);
              this.tabMenuOverlay && this.hideMenu();
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function initializeTabs() {
        return _initializeTabs.apply(this, arguments);
      }
      return initializeTabs;
    }()
    /**
     * When the tabs component first Updates, it waits for the slotted
     * tab, and tab panel components, selects the appropriate tab, hides the rest,
     * and applies some attributes from the tabs component to each tab/ tab panel, then
     * hides the tabMenuOverlay if it's shown.
     */
  }, {
    key: "firstUpdated",
    value: function () {
      var _firstUpdated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.variant !== d.PRIMARY && (this.scrollable = !0);
              _context4.next = 3;
              return this.initializeTabs();
            case 3:
              this.validateSlotChildrenMin(te);
              this.variant === d.PRIMARY ? this.tabsResizeObserver.observe(this.tabListElement) : (this.validateSlotChildrenMax(this.currentMaxTabs), this.tabsResizeObserver.observe(document.body));
              this.renderLightDOMStyles();
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function firstUpdated() {
        return _firstUpdated.apply(this, arguments);
      }
      return firstUpdated;
    }()
    /**
     * renders a `<beacon-tab>` component with the more attribute set to true
     * and an icon matching the `<beacon-tabs>` tab type property
     * @returns An HTML `<beacon-tab>` with more attribute set to true and a slotted more icon
     */
  }, {
    key: "renderMoreButton",
    value: function renderMoreButton() {
      return k(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<", "\n      label=\"More\"\n      variant=", "\n      tab-type=", "\n      value=\"-1\"\n      @beacon-event-click=", "\n      more\n    >\n      <svg slot=\"tab-icon\" width=\"17\" height=\"4\" viewBox=\"0 0 17 4\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <circle cx=\"2.5\" cy=\"2\" r=\"2\" fill=\"white\" />\n        <circle cx=\"8.5\" cy=\"2\" r=\"2\" fill=\"white\" />\n        <circle cx=\"14.5\" cy=\"2\" r=\"2\" fill=\"white\" />\n      </svg>\n    </", ">"])), this.getScopedTag("beacon-tab"), this.variant, this.tabType, this.showMenu, this.getScopedTag("beacon-tab"));
    }
    /**
     * Renders a dialog containing the mapped values of the slotted tabs
     * @returns an HTML dialog containing a tablist of mapped tab items
     */
  }, {
    key: "renderMoreMenu",
    value: function renderMoreMenu() {
      return g(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["<div class=\"overlay hide\" @click=", " id=\"menu\">\n      <dialog>\n        <div class=\"close-button-row\">\n          ", "\n        </div>\n        <div class=\"menu-item\">\n          <h2>", "</h2>\n        </div>\n        <div class=\"menu-tablist\" role=\"tablist\">", "</div>\n      </dialog>\n    </div>"])), this.handleMenuClickBlur, k(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["<", " @beacon-event-click=", " label=\"close-button\" variant=\"primary\">\n            <svg slot=\"icon\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n              <path d=\"M13 1L0.999999 13\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n              <path d=\"M1 1L13 13\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n            </svg>\n          </", ">"])), this.getScopedTag("beacon-icon-button"), this.handleClose, this.getScopedTag("beacon-icon-button")), this.menuTitle, this.buildTabMenu(this.tabChildren));
    }
  }, {
    key: "render",
    value: function render() {
      return g(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["<div class=\"container\">\n        <div id=\"tab-list\" role=\"tablist\" class=\"tablist\">\n          <slot name=\"tab-children\" @beacon-event-click=", " @slotchange=", "></slot>\n          ", "\n        </div>\n      </div>\n      <div class=\"spacer\"></div>\n      <slot name=\"tab-panel\" @slotchange=", "></slot>\n      ", ""])), this.handleTabClick, this.handleSlotChange, this.shouldShowMore ? this.renderMoreButton() : w, this.handleSlotChange, this.shouldShowMore ? this.renderMoreMenu() : w);
    }
  }, {
    key: "shouldShowMore",
    /**
     * Getter for a Boolean property indicating whether the more button and more menu should be rendered
     */
    get: function get() {
      return !this.scrollable && this.currentTotalTabs > this.currentMaxTabs && this.variant === d.PRIMARY;
    }
    /**
     * Getter for the Scroll Width of the tab list, used in calculating overflow
     */
  }, {
    key: "TabsWidth",
    get: function get() {
      return this.tabListElement.scrollWidth;
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(n), "styles", this), G];
    }
  }, {
    key: "lightDOMStyles",
    get: function get() {
      return [_get(_getPrototypeOf(n), "lightDOMStyles", this), U];
    }
  }]);
  return n;
}(S(R, P()));
n.tagName = L;
n.nestedComponents = H;
s([v("#menu")], n.prototype, "tabMenuOverlay", 2);
s([v("#menu dialog")], n.prototype, "tabMenu", 2);
s([D("#menu button.menu-item")], n.prototype, "menuTabs", 2);
s([v('#menu dialog .close-button-row [beacon-tag-name="beacon-icon-button"]')], n.prototype, "closeButton", 2);
s([v("#menu dialog .close-button-row")], n.prototype, "closeButtonRow", 2);
s([v("#tab-list")], n.prototype, "tabListElement", 2);
s([v("[more]")], n.prototype, "moreButton", 2);
s([A({
  slot: "tab-children",
  selector: "beacon-tab"
}, !0)], n.prototype, "tabChildren", 2);
s([A({
  slot: "tab-panel",
  selector: "beacon-tab-panel"
}, !0)], n.prototype, "tabPanels", 2);
s([y()], n.prototype, "currentTotalTabs", 2);
s([y()], n.prototype, "currentMaxTabs", 2);
s([b({
  reflect: !0,
  type: Boolean
})], n.prototype, "scrollable", 2);
s([b({
  reflect: !0,
  type: Boolean
})], n.prototype, "scrolled", 2);
s([b({
  type: Boolean,
  attribute: "close-on-click-out"
})], n.prototype, "closeOnClickOut", 2);
s([b({
  reflect: !0
})], n.prototype, "variant", 2);
s([b({
  reflect: !0,
  attribute: "tab-type"
})], n.prototype, "tabType", 2);
s([b({
  attribute: "menu-title"
})], n.prototype, "menuTitle", 2);
s([b()], n.prototype, "selected", 2);
s([y()], n.prototype, "menuOpen", 2);
s([b({
  reflect: !0,
  attribute: "overflowing-x"
})], n.prototype, "markedAsOverflowingX", 2);
s([y()], n.prototype, "markedAsMenuOverFlowingY", 2);
s([b({
  reflect: !0
})], n.prototype, "id", 2);
export { n as BeaconTabs };